// const API_LINK = 'http://192.168.0.105/Panel%20Dealers%20(Zeeshan)/api/';
 const API_LINK = 'https://dashboard.paneldeals.com/api/';
export default API_LINK;
